/**
 * 菜单
 */

export default [
  {
    path: 'table',
    name: '表单内编辑',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/demo/table.vue`),
  },
  {
    path: '/vacnstandard/toindex.action',
    name: '人事云菜单连接-休假设置',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
  },
  {
    path: '/org/toOrgPage.action',
    name: '人事云菜单连接-机构管理',
    component: () => import ( /* webpackChunkName: "table" */ `@/views/pub/pubIndex.vue`),
    meta: {
      permission: ['hr_org_manage']
    }
  },
  {
    path: 'serve/groupTable',
    name: '表格分组',
    component: () => import ( /* webpackChunkName: "groupTable" */ `@/views/demo/serve/groupTable.vue`),
  },
  {
    path: 'serve/table',
    name: '表格',
    component: () => import ( /* webpackChunkName: "serveTable" */ `@/views/demo/serve/table.vue`),
  },
  {
    path: 'serve/dynamicTable',
    name: '动态表格',
    component: () => import ( /* webpackChunkName: "dynamicTable" */ `@/views/demo/serve/dynamicTable.vue`),
  },
  {
    path: 'tabs',
    name: 'tabs页签',
    component: () => import ( /* webpackChunkName: "tabs" */ `@/views/demo/tabs/tabs.vue`),
  },
  {
    path: 'form/form',
    name: 'form表单',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/form/form.vue`),
  },
  {
    path: 'form/dynamicForm',
    name: '动态表单',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/form/dynamicForm.vue`),
  },
  {
    path: 'form/customerCenter',
    name: '客户中心',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/form/customerCenter.vue`),
  },
  {
    path: 'batchParent',
    name: '批量导入',
    component: () => import ( /* webpackChunkName: "form" */ `@/components/ciic/batchIncrease/batchParent`),
  },
  {
    path: 'ceshi',
    name: '动态表单测试',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/ceshi.vue`),
  },
  {
    path: 'websocket',
    name: 'WebSocket测试',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/websocket/scoketTest.vue`),
  },
  {
    path: 'salary_template',
    name: '薪资模板',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/template/salaryTemplate.vue`),
  },
  {
    path: 'formUpload',
    name: '表格上传',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/formUpload/formUpload.vue`),
  },
  {
    path: 'approval',
    name: '工资审批',
    component: () => import ( /* webpackChunkName: "form" */ `@/views/demo/salary/approval.vue`),
  },
  {
    path: '/payrollSettings',
    name: '工资单设置',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/payrollSettings/payrollSetting.vue`),
  },
  {
    path: '/paymentWage',
    name: '工资发放',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salary/paymentWage.vue`),
  },
  {
    path: '/tax',
    name: '个税申报',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salary/tax.vue`),
  },
  {
    path: '/demo/wageHistory',
    name: '工资历史',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salary/wageHistory.vue`),
  },
  {
    path: 'salarySet',
    name: '薪酬设置',
    component: () => import ( /* webpackChunkName: "salarySet" */ `@/views/demo/salarySet/salarySet.vue`),
    children:[
      {
        path: '/',
        name: '薪酬组',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step2.vue`),
      },
      {
        path: '/salarySet/step1',
        name: '公司设置',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step1.vue`),
      },
      {
        path: '/salarySet/step2',
        name: '薪酬组',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step2.vue`),
      },
      {
        path: '/salarySet/step3',
        name: '工资模板',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step3.vue`),
      },
      {
        path: '/salarySet/step4',
        name: '审批流程',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step4.vue`),
      },
      {
        path: '/salarySet/step5',
        name: '工资单',
        component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/salarySet/step5.vue`),
      },

    ]
  },
  {
    path: '/treeSelect',
    name: '树形选择框',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/treeSelect/treeSelect.vue`),
  },
  {
    path: '/dataImport',
    name: '数据导入',
    component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/dataImport/dataImport.vue`),
  },
	{
		path: '/VueTour',
		name: '指引',
		component: () => import ( /* webpackChunkName: "step2" */ `@/views/demo/VueTour/VueTour.vue`),
	},
];
